"use client"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faXmark } from "@instadeepai/fontawesome-pro-regular"
import { useRouter } from "next/navigation"

import {
  Button,
  Card,
  IconButton,
  Input,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@shared/ui"

const FormField = ({
  label,
  children,
}: {
  label: string
  children: React.ReactNode
}) => (
  <div className="flex flex-col gap-1.5">
    <label className="text-sm font-medium text-gray-700">{label}</label>
    {children}
  </div>
)

export const ModuleConfigForm = ({ onClose }: { onClose: () => void }) => {
  const router = useRouter()

  const handleStartForge = () => {
    router.push("/forge/forging-progress")
  }

  return (
    <Card className="flex h-full flex-col border-gray-100 bg-gray-50 px-3 py-2">
      <div className="flex justify-end mb-2">
        <IconButton
          aria-label="Close"
          variant="secondary"
          icon={<FontAwesomeIcon icon={faXmark} />}
          onClick={onClose}
        />
      </div>
      <div className="space-y-4 px-4 overflow-auto">
        <FormField label="Name">
          <Input placeholder="e.g., 2 GPUs, 16 CPUs" />
        </FormField>
        <FormField label="Mode of Transportation">
          <Select>
            <SelectTrigger>
              <SelectValue placeholder="Select" />
            </SelectTrigger>
            <SelectContent className="h-min max-h-min">
              <SelectItem value="truck">Truck</SelectItem>
              <SelectItem value="uld">ULD</SelectItem>
            </SelectContent>
          </Select>
        </FormField>
        <FormField label="Daily Volume of Shipping">
          <Input placeholder="e.g. 20 trucks, 30 ULDs" />
        </FormField>
        <FormField label="Daily volume of products shipped">
          <Select>
            <SelectTrigger>
              <SelectValue placeholder="e.g. 400 distinct SKUs" />
            </SelectTrigger>
            <SelectContent className="h-min max-h-min">
              <SelectItem value="100">100 SKUs</SelectItem>
              <SelectItem value="400">400 SKUs</SelectItem>
              <SelectItem value="1000">1000 SKUs</SelectItem>
            </SelectContent>
          </Select>
        </FormField>
        <FormField label="Operational safety constraints when packing">
          <Input placeholder="e.g. axle load limits, weight balancing" />
        </FormField>
        <FormField label="Additional business rules">
          <Input placeholder="e.g. customer priority" />
        </FormField>
      </div>
      <div className="flex-grow" />
      <div className="mt-6 flex justify-end">
        <Button onClick={handleStartForge}>Start Forge</Button>
      </div>
    </Card>
  )
}
